import {Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {State as authState} from '@store/reducers/auth.reducers';
import {AppState, selectAuthState} from '@store/app.states';
import {FuseNavigationService} from '../../../../../@fuse/components/navigation/navigation.service';
import {Store} from '@ngrx/store';
import {AuthService} from '@app/services/auth/auth.service';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavbarComponent implements OnInit {
  // Private
  // tslint:disable-next-line:variable-name
  _variant: string;
  getState$: Observable<authState> = this.store.select(selectAuthState);
  lastUserId = -1;


  /**
   * Constructor
   *
   */
  constructor(
    // tslint:disable-next-line:variable-name
    private _elementRef: ElementRef,
    // tslint:disable-next-line:variable-name
    private _renderer: Renderer2,
    private store: Store<AppState>,
    private authService: AuthService,
  ) {
    // Set the private defaults
    this._variant = 'vertical-style-2';
  }

  ngOnInit() {

    this.getState$.subscribe((state) => {

      if (state.user && state.user.context && this.lastUserId !== state.user.id) {

        this.lastUserId = state.user.id;
        this.authService.rebuildNavigation();
      }

    });
  }


// -----------------------------------------------------------------------------------------------------
// @ Accessors
// -----------------------------------------------------------------------------------------------------

  /**
   * Variant
   */
  get variant(): string {
    return this._variant;
  }

  @Input()
  set variant(value: string) {
    // Remove the old class name
    this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

    // Store the variant value
    this._variant = value;

    // Add the new class name
    this._renderer.addClass(this._elementRef.nativeElement, value);
  }
}
